// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ba7B","right":"styles_right__YUOxy"};